import React, { useContext } from 'react';
import './styles.css';
import { FormasPagamento } from '../FormasPagamento';
import { GlobalContext } from '../../contexts/HomeContext';
import { Image } from '../Image';
import ImgDebito from '../../img/cartao_debito.png';
import ImgCredito from '../../img/cartao_credito.png';
import ImgApplePay from '../../img/Apple_Pay.png';
import ImgGooglePay from '../../img/Google_Pay.png';
import ImgPix from '../../img/pix_icon.png';

export const InformacaoPagamento = () => {
  const { dadosApp } = useContext(GlobalContext);
  const temPix = dadosApp.Empresa.Config.pix_habilitado === 1 && dadosApp.TipoApp === 'DELIVERY';
  const temPagamentoOnline = dadosApp.Empresa.Config.pagamento_online === 1 || temPix;

  return (
    <div className="modal-content-dialog cardShadow" style={{ border: 'none', margin: 10, marginTop: 20 }}>
      {temPagamentoOnline && (
        <div className="info-card-border-bottom" style={{ marginBottom: '25px' }}>
          <div className="info-card-content">
            <h6
              className="info-card-title"
              style={{ margin: '-25px -25px 15px', background: 'white', borderTop: 'none' }}
            >
              Pagamento pelo Site
            </h6>
            <p style={{ margin: '10px 0 15px', fontSize: '14px' }}>Pague online com toda a segurança.</p>
            <div className="">
              {dadosApp.Empresa.Config.pagamento_online === 1 && dadosApp.Empresa.Config.stripe === 1 && (
                <div className="form-group-col2">
                  <span
                    className="small-badge"
                    style={{
                      border: '2px solid #ced4da',
                      background: '#FFF',
                      cursor: 'pointer',
                      borderRadius: 10,
                      width: '100%',
                      color: '#64707c',
                      padding: '8px 15px',
                      textAlign: 'center',
                    }}
                  >
                    <Image srcLocal={ImgApplePay} alt="credito" />
                    {/* Apple Pay */}
                  </span>
                  <span
                    className="small-badge"
                    style={{
                      border: '2px solid #ced4da',
                      background: '#FFF',
                      cursor: 'pointer',
                      borderRadius: 10,
                      width: '100%',
                      color: '#64707c',
                      padding: '8px 15px',
                      textAlign: 'center',
                    }}
                  >
                    <Image srcLocal={ImgGooglePay} alt="credito" />
                    {/* Google Pay */}
                  </span>
                </div>
              )}

              {dadosApp.Empresa.Config.pagamento_online === 1 && (
                <span
                  className="small-badge"
                  style={{
                    border: '2px solid #ced4da',
                    background: '#FFF',
                    cursor: 'pointer',
                    borderRadius: 10,
                    width: '100%',
                    color: '#64707c',
                    padding: '8px 15px',
                  }}
                >
                  <Image srcLocal={ImgCredito} alt="credito" />
                  <small>Cartão de Crédito</small>
                </span>
              )}

              {dadosApp.Empresa.Config.debito_habilitado === 1 && (
                <span
                  className="small-badge"
                  style={{
                    border: '2px solid #ced4da',
                    background: '#FFF',
                    cursor: 'pointer',
                    borderRadius: 10,
                    width: '100%',
                    color: '#64707c',
                    padding: '8px 15px',
                  }}
                >
                  <Image srcLocal={ImgDebito} alt="credito" />
                  <small>Cartão de Débito</small>
                </span>
              )}

              {temPix && (
                <span
                  className="small-badge"
                  style={{
                    border: '2px solid #ced4da',
                    background: '#FFF',
                    cursor: 'pointer',
                    borderRadius: 10,
                    width: '100%',
                    color: '#64707c',
                    padding: '8px 15px',
                  }}
                >
                  <Image srcLocal={ImgPix} alt="pix" />
                  <small>Pix</small>
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      {dadosApp.FormasPagamento?.length > 0 && dadosApp.Empresa.Config.pagamento_portador === 1 && (
        <div className="info-card-border-bottom">
          <div className="info-card-content">
            <h6
              className="info-card-title"
              style={{ margin: '-25px -25px 15px', background: 'white', borderTop: 'none' }}
            >
              Pagamento na Entrega
            </h6>
            <FormasPagamento />
          </div>
        </div>
      )}
    </div>
  );
};
